var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileAppsSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.378,
    height: 148.001,
    viewBox: "0 0 150.378 148.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mobile_apps_sm-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 150.378,
    height: 148.001,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_179",
    "data-name": "Groupe 179",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_178",
    "data-name": "Groupe 178",
    transform: "translate(0 0)",
    clipPath: "url(#mobile_apps_sm-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_235",
    "data-name": "Trac\\xE9 235",
    d: "M78.2,2.242C53.016,9,40.359,28.345,29.047,44.84,16.1,63.724,9.115,73.9,11.864,86.3c3.353,15.122,18.871,23.122,27.639,27.641,21.149,10.9,62.768,21.154,84.413-.374C154.83,82.825,127.617,6.554,96.772.387c-5-1-11.874.058-18.571,1.855",
    transform: "translate(12.846 0.001)",
    fill: "#dbafbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_236",
    "data-name": "Trac\\xE9 236",
    d: "M9.575,39.948c5.242-.484,8.424-3.9,11.24-6.794,3.222-3.314,4.96-5.1,4.838-7.66-.15-3.124-2.964-5.247-4.553-6.447-3.834-2.893-11.764-6.359-16.81-2.816-7.2,5.058-4.4,21.166,1.526,23.45a9.013,9.013,0,0,0,3.76.267",
    transform: "translate(0 16.789)",
    fill: "#dbafbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_237",
    "data-name": "Trac\\xE9 237",
    d: "M46.8,133.8l49.024-10.247a8.758,8.758,0,0,0,6.58-10.487L82.837,19.453a8.758,8.758,0,0,0-10.23-6.976L23.583,22.724A8.759,8.759,0,0,0,17,33.211L36.571,126.83A8.76,8.76,0,0,0,46.8,133.8",
    transform: "translate(19.154 14.02)",
    fill: "#3b2a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_238",
    "data-name": "Trac\\xE9 238",
    d: "M77,22.236,80.447,38.72l2.69,12.86,3.436,16.44L88.82,78.772l4.6,22.037a7.5,7.5,0,0,1-3.43,7.936,5.973,5.973,0,0,1-.6.33,7.448,7.448,0,0,1-1.78.614l-11.292,2.36L67.446,113.9l-.381.081-.274.06-.248.051-3.768.787-7.628,1.592-10.258,2.146a7.5,7.5,0,0,1-8.88-5.809l-1.77-8.465-2.12-10.138L29.05,79.53,19.586,34.24A7.505,7.505,0,0,1,25.4,25.358l4.143-.867,38.584-8.065A7.5,7.5,0,0,1,77,22.236",
    transform: "translate(22.14 18.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_239",
    "data-name": "Trac\\xE9 239",
    d: "M73.686,26.76l2.69,12.862a28.534,28.534,0,0,1-4.688.633c-2.707.141-5.431.036-8.129.359a22.575,22.575,0,0,0-11.422,4.8,8.489,8.489,0,0,0-2.482,2.891c-1,2.135-.687,4.641-.569,6.916.261,5.052.214,10.26-1.519,15.079a25.055,25.055,0,0,1-7.846,11.02c-2.078,1.667-4.474,2.839-6.635,4.384a17.681,17.681,0,0,0-4.695,5.067c-.332.531-.633,1.07-.912,1.616l-2.121-10.14c.948-.98,1.96-1.9,2.994-2.788,3.152-2.711,6.653-5.2,9.132-8.589A14.764,14.764,0,0,0,40.1,65.062c.488-2.424.451-4.915.783-7.361a18.392,18.392,0,0,1,6.244-11.182c3.689-3.327,8.129-5.377,12.524-7.581a39.673,39.673,0,0,0,6.578-3.978,31.667,31.667,0,0,0,4.6-4.361,32.74,32.74,0,0,0,2.861-3.839",
    transform: "translate(28.901 30.501)",
    fill: "#dbafbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_240",
    "data-name": "Trac\\xE9 240",
    d: "M64.176,25.993l3.5,16.369a3.557,3.557,0,0,1-2.732,4.22l-16.369,3.5c-.062.013-.124.026-.188.034a3.551,3.551,0,0,1-4.031-2.767l-3.5-16.369a3.552,3.552,0,0,1,2.732-4.22l16.369-3.5a3.555,3.555,0,0,1,4.22,2.732",
    transform: "translate(46.473 26.421)",
    fill: "#ea275c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_241",
    "data-name": "Trac\\xE9 241",
    d: "M70.816,46.814l.353,16.735a3.552,3.552,0,0,1-2.651,3.513,3.421,3.421,0,0,1-.828.116l-16.735.353c-.064,0-.128,0-.19,0a3.553,3.553,0,0,1-3.439-3.477l-.353-16.737a3.553,3.553,0,0,1,3.479-3.629l16.735-.353a3.554,3.554,0,0,1,3.629,3.479",
    transform: "translate(53.536 49.39)",
    fill: "#ea275c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_242",
    "data-name": "Trac\\xE9 242",
    d: "M49.566,26.874l1.361,16.684a3.553,3.553,0,0,1-3.252,3.832L30.989,48.751c-.062.006-.126.009-.19.011A3.555,3.555,0,0,1,27.156,45.5L25.8,28.812A3.555,3.555,0,0,1,29.05,24.98l16.684-1.361a3.555,3.555,0,0,1,3.832,3.255",
    transform: "translate(29.387 26.907)",
    fill: "#ea275c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_243",
    "data-name": "Trac\\xE9 243",
    d: "M44.008,12.923l4.6,11.546a2.634,2.634,0,0,1-.931,3.133,2.6,2.6,0,0,1-.544.3L35.588,32.5c-.043.017-.088.034-.133.049a2.639,2.639,0,0,1-3.3-1.524l-4.6-11.546a2.636,2.636,0,0,1,1.474-3.428l11.546-4.6a2.639,2.639,0,0,1,3.428,1.474",
    transform: "translate(31.196 12.834)",
    fill: "#ea275c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_244",
    "data-name": "Trac\\xE9 244",
    d: "M30.334,7.266l-.458,8.645a1.838,1.838,0,0,1-1.5,1.71,1.808,1.808,0,0,1-.432.028L19.3,17.19c-.034,0-.066,0-.1-.009a1.838,1.838,0,0,1-1.641-1.924l.458-8.645a1.841,1.841,0,0,1,1.934-1.74l8.645.46a1.838,1.838,0,0,1,1.737,1.932",
    transform: "translate(20.011 5.552)",
    fill: "#ea275c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_245",
    "data-name": "Trac\\xE9 245",
    d: "M53.309,40.072l4.63,16.087a3.551,3.551,0,0,1-2.433,4.4l-16.085,4.63c-.062.017-.124.034-.186.047a3.552,3.552,0,0,1-4.215-2.48L30.39,46.669a3.555,3.555,0,0,1,2.433-4.4l16.087-4.63a3.554,3.554,0,0,1,4.4,2.433",
    transform: "translate(34.478 42.741)",
    fill: "#ea275c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAppsSm);
export default __webpack_public_path__ + "static/media/mobile_apps_sm.e8053019d6f004d179851a34022e6d7d.svg";
export { ForwardRef as ReactComponent };